import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { BreadCrumb, PageLayouts, SettingsFormViewPanel } from "components/common";
import { useParams } from "react-router-dom";
import { useCustomerService } from "serviceHooks";
import GeneralSettingsFormContainer from "./forms/generalSettingsFormContainer";
import InvoiceSettingsFormContainer from "./forms/invoiceSettingsFormContainer";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const CustomerSettings: React.FC = () => {
  const customerService = useCustomerService();
  const urlParams = useParams<EntityIdParams>();
  const id = Number.parseInt(urlParams.id ?? "0");

  const [customer, setCustomer] = React.useState<WintSuperkollAPIModel.Customer>();

  const loadCustomer = async () => {
    const result = await customerService.getCustomer(id);
    setCustomer(result);
  };

  React.useEffect(() => {
    loadCustomer();
  }, [id]);

  return (
    <PageLayouts.EntityFullScreen
      entityKey={`customer-settings`}
      id={id ?? 0}
      navigation={
        <BreadCrumb
          prevItems={[
            {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.Customers),
              href: UrlHelper.formatPath("/Reports/Customers"),
            },
            { text: customer?.name ?? "", href: UrlHelper.formatPath(`/Customer/${id}/`) },
          ]}
          current={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Settings)}
          showHome
        />
      }
    >
      {customer ? (
        <PageLayouts.SettingsLayout
          title={customer?.name ?? ""}
          navItems={[
            {
              navKey: "customerSettings",
              title: TranslationKeys.Invoice.ClientDetails,
              icon: IconDefinitionConstants.WInfo,
              content: (
                <SettingsFormViewPanel onSubmitSuccess={loadCustomer}>
                  <GeneralSettingsFormContainer
                    organizationNumberChangeHandler={() => {}}
                    selectedCustomerChangeHandler={() => {}}
                    customer={customer}
                  />
                </SettingsFormViewPanel>
              ),
            },
            {
              navKey: "invoiceSettings",
              title: TranslationKeys.Common.Invoicing,
              icon: IconDefinitionConstants.WSend,
              content: (
                <SettingsFormViewPanel onSubmitSuccess={loadCustomer}>
                  <InvoiceSettingsFormContainer
                    organizationNumberChangeHandler={() => {}}
                    selectedCustomerChangeHandler={() => {}}
                    customer={customer}
                  />
                </SettingsFormViewPanel>
              ),
            },
          ]}
        ></PageLayouts.SettingsLayout>
      ) : (
        <></>
      )}
    </PageLayouts.EntityFullScreen>
  );
};

export default CustomerSettings;
